import { dynamicLoader } from '~/utils';

export const BaseLayout = dynamicLoader({
  name: 'BaseLayout',
  importFunc: () => import('./base-layout'),
});